/**
 * Vocabulary 8 calculator anketa types — для `/calculator/:type` routing
 * и methodology API (GET /api/calculator/methodology/:type).
 *
 * **Отличается от `quote-furniture-types-vocabulary.ts`** — там 10 типов для Quote
 * `furnitureType` field (Кухня/Прихожая/Гардероб/.../Прочее, см. PRD §10 Экран 2.12.10
 * и ADR-0019 §Q9 auto-counter naming).
 * Anketa types — это **анкеты калькулятора**, для каждой свой набор полей + формул.
 *
 * Также **отличается от Block 6 `configurator-vocabularies.ts` FURNITURE_TYPES** —
 * там 9 английских ключей для 3D-визуализации configurator. Block 12 anketa types и
 * Block 6 configurator furniture types — три отдельных concepts (P-033 spirit).
 *
 * Russian labels — для UI рендера в `<CalculatorEntry />` (Экран 2.12.1).
 *
 * References:
 *   - ADR-0019 §Q1 (5 PRs split), §Q2 (methodology endpoint), §Q5 (AnketaForm template)
 *   - PRD `docs/prd/v4/10-block-12-calculator.md` §«Экраны 2.12.1–2.12.9»
 *   - Reference pattern: `domain/feedback-tags-vocabulary.ts` (Block 10 ADR-0018 §Q2)
 */

export const CALCULATOR_ANKETA_TYPES = [
  'kitchen',
  'cabinet',
  'bath-tabletop',
  'bath-shelf-above',
  'bath-cabinet',
  'tv-zone',
  'balcony',
  'other',
] as const;

export type CalculatorAnketaType = (typeof CALCULATOR_ANKETA_TYPES)[number];

/**
 * Русские лейблы для UI Экрана 2.12.1 (список 8 анкет).
 * Источник истины — здесь; LinguiJS-локализация UZ/KZ — отдельная фаза.
 */
export const CALCULATOR_ANKETA_TYPE_LABELS: Record<CalculatorAnketaType, string> = {
  kitchen: 'Кухня',
  cabinet: 'Шкаф / Гардероб',
  'bath-tabletop': 'Санузел: Тумба со столешницей',
  'bath-shelf-above': 'Санузел: Шкаф над антресолью',
  'bath-cabinet': 'Санузел: Шкаф',
  'tv-zone': 'ТВ-зона в гостиную',
  balcony: 'Шкаф на балкон',
  other: 'Другая мебель',
};

/** Type guard: проверяет что произвольное значение — валидный `CalculatorAnketaType`. */
export function isCalculatorAnketaType(value: unknown): value is CalculatorAnketaType {
  return (
    typeof value === 'string' && (CALCULATOR_ANKETA_TYPES as readonly string[]).includes(value)
  );
}
